import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpContextToken,
  HttpContext
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../../shared/services/notification/notification.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

const CUSTOM_ERROR_MESSAGE = new HttpContextToken<ErrorToken[]>(() => null);
const SKIP_INTERCEPT = new HttpContextToken<{}>(() => null);

export function createCustomErrorContext(errorToken: ErrorToken[]) {
  return new HttpContext().set(CUSTOM_ERROR_MESSAGE, errorToken);
}

export function createSkipInterceptContext() {
  return new HttpContext().set(SKIP_INTERCEPT, {});
}

export function getGeneralErrorMessage(error: HttpErrorResponse): string {
  let errorMsg: string;
  if(error.error?.message ) {
    errorMsg = `<b>URL:</b> ${error.url},<br><b>Error Code:</b> ${error.status},<br><b>Message:</b> ${error.error.message}`;
  } else if(error.error && (typeof error.error) === 'string') {
    errorMsg = `<b>URL:</b> ${error.url},<br><b>Error Code:</b> ${error.status},<br><b>Message:</b> ${error.error}`;
  } else {
    errorMsg = `<b>URL:</b> ${error.url},<br><b>Error Code:</b> ${error.status},<br><b>Message:</b> ${error.message}`;
  }
  return errorMsg;
}

export interface ErrorToken {
  status: number;
  message: string,
  data?: any
}

@Injectable()
export class GenericErrorHandlingInterceptor implements HttpInterceptor {

  constructor(
    private notification: NotificationService,
    private translate: TranslateService
    ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if(!request.url.includes(environment.resellingApi)) {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg: string;
          if(request.context.get(CUSTOM_ERROR_MESSAGE)) {
            let errorList = request.context.get(CUSTOM_ERROR_MESSAGE);
            errorMsg = this.getCustomErrorMessage(error, errorList);
          } else if(request.context.get(SKIP_INTERCEPT)) {
            return throwError(error);
          } else {
            errorMsg = getGeneralErrorMessage(error);
          }
          this.notification.error(errorMsg);
          return throwError(error);
        })
      );
    } else {
      return next.handle(request);
    }
  }

  private getCustomErrorMessage(error: HttpErrorResponse, errorList: ErrorToken[]): string {
    let errorMsg: string;
    let currentError = errorList.find(el => el.status === error.status);
    if(currentError) {
      errorMsg = currentError.message;
      if(currentError.data?.value) {
        errorMsg = this.translate.instant(
          errorMsg,
          { value: currentError.data.value }
        );
      }
    } else {
      errorMsg = getGeneralErrorMessage(error);
    }
    return errorMsg;
  }
}
